
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/AppErrorBoundary",
      function () {
        return require("private-next-pages/AppErrorBoundary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/AppErrorBoundary"])
      });
    }
  